<div class="container">
  @if (previewForm) {
    <div class="card-header pb-2 pt-2">
      <h5>LIVE-Vorschau (Einige Funktionen nicht verfügbar)</h5>
    </div>
    <div class="card p-3">
      <app-form [form]="previewForm" [isPreview]="true"/>
    </div>
  } @else {
    <div class="alert alert-secondary">
      Das Formular wird angezeigt, sobald Sie eine Änderung vornehmen.
    </div>
  }
</div>


